const DISCOUNTS_WRAPPER_CLASSNAME = 'blaze-ecommerce-discounts';
const PLACHOLDER = 'Discount or voucher code';

export { DISCOUNTS_WRAPPER_CLASSNAME, PLACHOLDER };
